"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const stores_1 = require("./stores");
const App_1 = require("./App");
sdk_1.default.ready();
const AppWrapper = () => {
    const TgObj = sdk_1.default;
    // TgObj.ready()
    // TgObj.enableClosingConfirmation()
    // TgObj.expand()
    const rootStore = new stores_1.RootStore();
    return ((0, jsx_runtime_1.jsx)(stores_1.StoreProvider, { store: rootStore, children: (0, jsx_runtime_1.jsx)(App_1.App, {}) }));
};
exports.AppWrapper = AppWrapper;
